<template>
  <div>
    <el-button class="newAdd" @click="openDialog" size="mini"
      >新增商务</el-button
    >
    <el-dialog
      title="新增商务"
      :visible.sync="moveDialogVisible"
      width="40%"
      center
      @close="clear"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="UID" :label-width="formLabelWidth" prop="userId">
          <div class="search">
            <el-input
              v-model="form.userId"
              class="searchIpt"
              autocomplete="off"
            ></el-input>
          </div>
        </el-form-item>

        <el-form-item
          label="商务类型"
          :label-width="formLabelWidth"
          prop="affairesType"
        >
          <el-select v-model="form.affairesType" placeholder="请选择商务类型">
            <el-option
              v-for="(item, index) in affairesTypeList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="上级商务"
          :label-width="formLabelWidth"
          prop="agentAffaires"
        >
          <el-input
            v-model="form.agentAffaires"
            class="searchIpt"
            autocomplete="off"
            :disabled="disabled"
          />
        </el-form-item>
        <!-- <el-form-item
          label="是否为商务"
          :label-width="formLabelWidth"
          prop="isAffaires"
        >
          <el-switch
            v-model="form.isAffaires"
            active-text="是 "
            inactive-text="否"
          >
          </el-switch>
        </el-form-item> -->
        <!-- <el-form-item label="otc返佣比例" :label-width="formLabelWidth" prop="otcRate" >
        <el-input v-model="form.otcRate" class="searchIpt" autocomplete="off">
          <template slot="append">%</template></el-input>
    </el-form-item> -->
      </el-form>
      <!-- <span slot="footer" class="dialog-footer">
            <el-button size="mini" type="primary" @click="add">添加</el-button>
            <el-button size="mini"  @click="clear">重置</el-button>
          </span> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="clear">取 消</el-button>
        <el-button type="primary" @click="add">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      moveDialogVisible: false,
      form: {
        agentAffaires: '',
        userId: '',
        //isAffaires: false,
        affairesType: 1,
      },
      disabled: false,
      formLabelWidth: '140px',
      rules: {
        userId: [{ required: true, message: '请输入UID', trigger: 'blur' }],
        rate: [{ required: true, message: '请输入比例', trigger: 'blur' }],
        otcRate: [
          { required: true, message: '请输入otc返佣比例', trigger: 'blur' },
        ],
      },
      affairesTypeList: [
        { value: 1, label: '普通商务' },
        { value: 2, label: '商务组长' },
        { value: 3, label: '商务总监' },
      ],
    }
  },
  methods: {
    ...mapActions('partnerList', ['addAffaires']),
    openDialog() {
      this.moveDialogVisible = true
    },
    add() {
      this.addAffaires(this.form).then((res) => {
        if (res.code == 0) {
          this.$message.success('添加成功')
          this.$emit('refresh')
          this.clear()
        } else {
          this.$message.error('添加失败')
          this.clear()
        }
      })
    },
    clearFiled() {
      this.$refs['form'].resetFields()
    },
    clear() {
      this.moveDialogVisible = false
      this.$refs['form'].resetFields()
    },
  },
  watch: {
    form: {
      handler(val, oldVal) {
        if (val.affairesType === 3) {
          this.disabled = true
          this.form.agentAffaires = ''
        } else {
          this.disabled = false
        }
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style lang="less" src="../../../../styles/button.less" scoped>
.content {
  // border: 1px solid #f5f6f7;
  padding: 20px;
  width: 100%;
  height: 200px;
  .up {
    border: 1px solid #f5f6f7;
    width: 100%;
    height: 50%;
    display: flex;
  }
  .down {
    border: 1px solid #f5f6f7;
    width: 100%;
    height: 50%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .item {
    border-right: 1px solid #f5f6f7;
    display: flex;
    width: 50%;
    height: 100%;
    justify-content: center;
    align-items: center;
    .ipt {
      width: 90%;
    }
  }
}
.btn1 {
  display: flex;
  justify-content: center;
  width: 300px;
  margin: 0 auto;
}
</style>
